import "core-js/modules/es.string.link.js";
/* eslint-disable react/prop-types */
import React from 'react';
import MiddleTruncate from 'react-middle-truncate/lib/react-middle-truncate';
import { DOWNLOAD_ICON } from "../../../../../util/cdnAssets";
import { _RequirementAttachmentWrapper, _RequirementAttachment, _DownloadLink } from "./style";
function RequirementAttachment(_ref) {
  var link = _ref.link,
    fileName = _ref.fileName;
  if (!link) throw new Error("missing prop 'link'");
  if (!fileName) throw new Error("missing prop 'fileName'");
  return /*#__PURE__*/React.createElement(_RequirementAttachmentWrapper, null, /*#__PURE__*/React.createElement(_RequirementAttachment, {
    href: link,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(MiddleTruncate, {
    text: fileName,
    start: 10,
    end: 5
  })), /*#__PURE__*/React.createElement(_DownloadLink, {
    href: link,
    download: fileName,
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    src: DOWNLOAD_ICON,
    alt: "Download"
  })));
}
export default RequirementAttachment;